// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1G5RE","title":"Images90_title__DdACQ","images":"Images90_images__3Lz5w"};